export default {
  "content": "<title>Icons/Upward Joining Arrow</title><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#DFF5EE\" cx=\"24\" cy=\"24\" r=\"24\"/><path d=\"M24 13v22M29 17h-7.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H18\" stroke=\"#5D2193\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};